import { css, cva, sva } from "@stubhub/broadway-foundation/css";

export const cardClass = cva({
  base: {
    display: "flex",
    flexDirection: "column",
    rowGap: "primitives.75",
    borderBlockStartWidth: "thin",
    borderBlockEndWidth: "thin",
    borderInlineStartWidth: "thin",
    borderInlineEndWidth: "thin",
    borderBlockStartStyle: "solid",
    borderBlockEndStyle: "solid",
    borderInlineStartStyle: "solid",
    borderInlineEndStyle: "solid",
    borderBlockStartColor: "border",
    borderBlockEndColor: "border",
    borderInlineStartColor: "border",
    borderInlineEndColor: "border",
    borderStartStartRadius: "primitives.150",
    borderStartEndRadius: "primitives.150",
    borderEndStartRadius: "primitives.150",
    borderEndEndRadius: "primitives.150",
    paddingBlockStart: "primitives.150",
    paddingBlockEnd: "primitives.150",
    paddingInlineStart: "primitives.150",
    paddingInlineEnd: "primitives.150",
  },
  variants: {
    size: {
      default: { minWidth: "[280px]", maxWidth: "[280px]" },
      mobile: { minWidth: "[250px]", maxWidth: "[250px]" },
    },
  },
  defaultVariants: {
    size: "default",
  },
});

export const listItemContainerClass = css({
  paddingInline: "[0px]",
  paddingBlock: "primitives.75",
});

export const separatorClass = css({
  borderBlockStartWidth: "thin",
  borderBlockStartColor: "border",
  borderInlineStartWidth: "none",
  borderInlineEndWidth: "none",
  borderBlockEndWidth: "none",
});

export const title = css({});

export const calenderStyles = {
  container: css({
    borderBlockColor: "bg.surface.strong",
    borderInlineColor: "bg.surface.strong",
  }),
  contentContainer: css({
    backgroundColor: "bg.surface.strong",
  }),
  contentSecondary: css({
    color: "text.subtle",
  }),
};

export const contentStyles = {
  container: css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  }),
};

export const titleStyles = {
  group: css({
    fontSize: "primitives.300",
  }),
};

export const eventEntryFallbackFlagRecipe = sva({
  slots: ["fallbackFlagContainer", "fallbackFlag"] as const,
  className: "eventEntryFallbackFlag",
  base: {
    fallbackFlagContainer: {
      display: "inline-flex",
      height: "[16px]",
      aspectRatio: "3 / 2",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "bg.surface.stronger",
      borderStartRadius: "primitives.50",
      borderEndRadius: "primitives.50",
    },
    fallbackFlag: {
      color: "text.subtle",
    },
  },
});
